module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "file_032"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "sidebartitle"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• 0.07 oz. (2 g) red wool")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• 0.07 oz. (2 g) black wool")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• small amount of yellow and white wool")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• craft glue")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• small rare earth magnet")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• beads for eyes")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• beading needle and thread")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• felting needle")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• foam pad")]), _vm._v(" "), _c('p', {
    staticClass: "bulitlist"
  }, [_vm._v("• ruler")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed45b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_032.vue
// module id = 147
// module chunks = 0